<svg viewBox="0 0 51.25 22.1">
  <defs>
    <style>
      .cls-1 {
        fill: #ECC036;
      }
    </style>
  </defs>
  <title>Asset 17</title>
  <g id="Layer_2" data-name="Layer 2">
    <g id="Layer_1-2" data-name="Layer 1">
      <rect class="cls-1" width="51.25" height="22.1" />
      <path
        d="M20.16,9.77c0,2.07-1.3,3.28-3.55,3.28H15v2.44h-2.3V6.67h3.87C18.86,6.67,20.16,7.81,20.16,9.77ZM18,9.84c0-.86-.54-1.33-1.47-1.33H15v2.7H16.5A1.28,1.28,0,0,0,18,9.84Z" />
      <path d="M23.59,6.16v9.33H21.36V6.16Z" />
      <path
        d="M32,8.69v6.8H29.77V14.38a2.41,2.41,0,0,1-2.18,1.21A2.36,2.36,0,0,1,25.17,13V8.69h2.24v3.65c0,.77.42,1.24,1.09,1.24s1.27-.64,1.27-1.54V8.69Z" />
      <path
        d="M36.1,10.14c-.38,0-.64.14-.64.43,0,.89,3.57.47,3.55,2.83,0,1.4-1.22,2.19-2.88,2.19a5,5,0,0,1-3.06-1l.7-1.45a4.36,4.36,0,0,0,2.42.85c.41,0,.71-.14.71-.42,0-.93-3.51-.46-3.51-2.81,0-1.42,1.2-2.2,2.8-2.2A5.44,5.44,0,0,1,39,9.38l-.75,1.46A5.19,5.19,0,0,0,36.1,10.14Z" />
    </g>
  </g>
</svg>